module.exports = __webpack_public_path__ + "assets/img/tips.408e692a.svg";